export const hasAgencyAccess = (user) =>
  Boolean(user?.agenceId || user?.company?.agenceId || user?.company?.agence);

export const isAgencyRoute = (pathname = "") => {
  const lower = pathname.toLowerCase();
  return (
    lower === "/chat" ||
    lower.startsWith("/chat/") ||
    lower.startsWith("/comptabilite") ||
    lower === "/document" ||
    lower.startsWith("/document/") ||
    lower === "/importation-doc" ||
    lower.startsWith("/importation-doc/")
  );
};
